export const ENTRY_CONCEPT_IDS = [
  'digital-life',
  'idea-to-creation',
  'ai-team',
  'second-brain',
  'space-for-you',
] as const

export const entryMessages = {
  ru: {
    landing: {
      studioName: 'Аита',
      studioTitle: 'ИИ-модели. Обучение. Готовые решения.',
      studioDescription:
        'Работай с разными нейросетями в одном окне, учись применять их и используй готовые решения для своих задач.',
      studioCaption: 'От первого запроса до готового результата.',
      studioPrompt: 'Напиши пост о моём проекте',
      studioReply: 'Соберём идею, структуру и черновик поста.',
      studioTasks: {
        post: 'Напиши пост',
        presentation: 'Подготовь презентацию',
        product: 'Сделай карточку товара',
      },
      assistantTitle: 'Помощник, который в теме.',
      assistantDescription:
        'Настрой ИИ-агента под свои задачи. Ты задаёшь направление — он помогает с контентом, анализом и повседневной работой.',
      assistantTask: 'Собери контент-план на неделю',
      assistantResult: 'Вот идеи для твоих публикаций.',
      agentTitle: 'Помощник, который в теме.',
      agentDescription:
        'Настрой AI-агента под свои задачи. Он помогает с контентом и аналитикой. Ты задаёшь направление.',
      agentPrompt: 'Собери контент-план на неделю',
      agentAnswer: 'Вот идеи для семи публикаций.',
      progressTitle: 'Развитие, в которое хочется играть.',
      progressDescription:
        'Проходи уровни, развивай AI-команду и отмечай свой прогресс.',
      levels: {
        F1: 'Первый агент',
        F6: 'Команда растёт',
        F12: 'Твоё AI-агентство',
      },
      progressCaption: 'GG Points · Ранги · Челленджи',
      communityEyebrow: 'Закрытое комьюнити',
      communityTitle: 'Твои люди. Общий путь.',
      communityDescription:
        'Живые разборы, общие челленджи и поддержка команды. Здесь делятся тем, что сделали с AI.',
      communityItems: {
        explore: 'Разбираем',
        create: 'Создаём',
        help: 'Помогаем',
      },
      communityCaption: 'Доступ к чатам зависит от уровня участия.',
      joinTitle: 'Начни со своей первой задачи.',
      joinDescription: 'Твой AI. Твоя команда. Твоя гонка.',
      joinCta: 'Присоединиться',
      joinCaption: 'Регистрация бесплатна.',
    },
    eyebrow: 'Нейросети · ИИ-агенты · GNK',
    concepts: {
      'digital-life': {
        title: 'Нейросети для',
        words: {
          one: 'текстов.',
          two: 'изображений.',
          three: 'исследований.',
          four: 'твоих проектов.',
        },
        description:
          'Gonka Game объединяет ИИ-инструменты по одной подписке. Пиши, создавай изображения и исследуй в одном месте.',
      },
      'idea-to-creation': {
        title: 'Создавай с ИИ',
        words: {
          one: 'сайты.',
          two: 'контент.',
          three: 'иллюстрации.',
          four: 'свои продукты.',
        },
        description:
          'Gonka Game — ИИ-инструменты для твоих идей: от текста и картинки до сайта и цифрового продукта.',
      },
      'ai-team': {
        title: 'Применяй ИИ',
        words: {
          one: 'в работе.',
          two: 'в контенте.',
          three: 'в своём проекте.',
          four: 'в бизнесе.',
        },
        description:
          'В Gonka Game есть обучение с нуля: учись выбирать ИИ-инструмент под задачу и создавать свои первые проекты.',
      },
      'second-brain': {
        title: 'Твой второй пилот',
        words: {
          one: 'пишет.',
          two: 'ищет.',
          three: 'анализирует.',
          four: 'помогает учиться.',
        },
        description:
          'Gonka Game развивает личных ИИ-агентов для текстов, поиска и анализа. Агент помогает — решения принимаешь ты.',
      },
      'space-for-you': {
        title: 'Осваивай ИИ',
        words: {
          one: 'с наставником.',
          two: 'с командой.',
          three: 'с поддержкой.',
          four: 'в сообществе.',
        },
        description:
          'Gonka Game — ИИ-инструменты и сообщество. Разбирай задачи с наставниками и делись тем, что создаёшь с ИИ.',
      },
    },
    signIn: 'Войти',
    emailHint: 'Введи email, чтобы войти или создать аккаунт.',
    name: 'Как тебя зовут?',
    journey: 'Следующий шаг — твой.',
    journeyHint: 'Продолжим в твоём личном пространстве.',
    ecosystem: 'Gonka — децентрализованный ИИ. GNK — токен его экосистемы.',
    studio: 'Нейросети в AITA.center',
    pause: 'Остановить анимацию',
    play: 'Включить анимацию',
  },
  en: {
    landing: {
      studioName: 'Aita',
      studioTitle: 'AI models. Learning. Ready-to-use solutions.',
      studioDescription:
        'Use different AI models in one window, learn how to apply them and put ready-to-use solutions to work.',
      studioCaption: 'From your first prompt to a finished result.',
      studioPrompt: 'Write a post about my project',
      studioReply: 'Let’s put together an idea, an outline and a draft.',
      studioTasks: {
        post: 'Write a post',
        presentation: 'Prepare a presentation',
        product: 'Create a product card',
      },
      assistantTitle: 'An assistant who gets it.',
      assistantDescription:
        'Set up an AI agent for your tasks. You set the direction — it helps with content, analysis and everyday work.',
      assistantTask: 'Create a content plan for the week',
      assistantResult: 'Here are ideas for your posts.',
      agentTitle: 'An assistant that gets it.',
      agentDescription:
        'Set up an AI agent for your tasks. It helps with content and analytics. You set the direction.',
      agentPrompt: 'Plan a week of content',
      agentAnswer: 'Here are ideas for seven posts.',
      progressTitle: 'Growth you want to play with.',
      progressDescription:
        'Move through levels, develop your AI team and track your progress.',
      levels: {
        F1: 'Your first agent',
        F6: 'Your team grows',
        F12: 'Your AI agency',
      },
      progressCaption: 'GG Points · Ranks · Challenges',
      communityEyebrow: 'Private community',
      communityTitle: 'Your people. A shared journey.',
      communityDescription:
        'Live reviews, shared challenges and team support. Share what you have created with AI.',
      communityItems: { explore: 'Explore', create: 'Create', help: 'Help' },
      communityCaption: 'Chat access depends on your participation level.',
      joinTitle: 'Start with your first task.',
      joinDescription: 'Your AI. Your team. Your race.',
      joinCta: 'Join us',
      joinCaption: 'Registration is free.',
    },
    eyebrow: 'AI tools · AI agents · GNK',
    concepts: {
      'digital-life': {
        title: 'AI tools for',
        words: {
          one: 'writing.',
          two: 'images.',
          three: 'research.',
          four: 'your projects.',
        },
        description:
          'Gonka Game brings AI tools together in one subscription. Write, create images and research in one place.',
      },
      'idea-to-creation': {
        title: 'Use AI to create',
        words: {
          one: 'websites.',
          two: 'content.',
          three: 'illustrations.',
          four: 'your own products.',
        },
        description:
          'Gonka Game is your AI toolkit for creating text, images, websites and digital products from your ideas.',
      },
      'ai-team': {
        title: 'Put AI to work',
        words: {
          one: 'on daily tasks.',
          two: 'on your content.',
          three: 'on your projects.',
          four: 'in your business.',
        },
        description:
          'Gonka Game offers beginner lessons: learn to choose AI tools for the task and build your first projects.',
      },
      'second-brain': {
        title: 'Your AI co-pilot',
        words: {
          one: 'writes.',
          two: 'searches.',
          three: 'analyses.',
          four: 'helps you learn.',
        },
        description:
          'Gonka Game is developing personal AI agents for writing, search and analysis. Your agent helps; you make the decisions.',
      },
      'space-for-you': {
        title: 'Learn AI',
        words: {
          one: 'with a mentor.',
          two: 'with a team.',
          three: 'with support.',
          four: 'in a community.',
        },
        description:
          'Gonka Game brings AI tools and a community together. Work through tasks with mentors and share what you create with AI.',
      },
    },
    signIn: 'Sign in',
    emailHint: 'Enter your email to sign in or create an account.',
    name: 'What’s your name?',
    journey: 'Your next move.',
    journeyHint: 'Let’s continue in your personal space.',
    ecosystem: 'Gonka is decentralized AI. GNK is its ecosystem token.',
    studio: 'AI tools in AITA.center',
    pause: 'Pause animation',
    play: 'Play animation',
  },
}
